module.exports = __webpack_public_path__ + "static/img/products3.17ffec05.png";